import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Section } from './ui/Section';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function Pricing() {
  return <Section id="pricing" className="text-center" data-id="element-83">
      <FadeIn data-id="element-84">
        <div className="bg-white rounded-2xl border border-warm-border shadow-lg p-8 md:p-12 max-w-xl mx-auto relative overflow-hidden" data-id="element-85">
          <div className="absolute top-0 left-0 w-full h-2 bg-accent-teal" data-id="element-86"></div>

          <div className="flex justify-center mb-6" data-id="element-87">
            <img src="https://cdn.magicpatterns.com/uploads/5T2ckXm6hkFVhusVfURXAX/heylloyd-image-1770455569538.png" alt="Monotributista en Calma — Ebook" className="w-40 md:w-48 h-auto drop-shadow-lg" data-id="element-88" />
          </div>

          <h2 className="text-3xl font-bold mb-2" data-id="element-89">Monotributista en Calma</h2>
          <p className="text-text-secondary mb-8" data-id="element-90">
            Acceso inmediato al PDF + plantillas
          </p>

          <div className="mb-8" data-id="element-91">
            <span className="text-5xl font-bold text-text-primary tracking-tight" data-id="element-92">
              $6.360
            </span>
            <span className="text-xl text-text-secondary ml-2" data-id="element-93">ARS</span>
          </div>

          <a href="https://argrutinas.com/cart/42965794357457:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window.fbq === 'function') {
            window.fbq('track', 'AddToCart');
          }
        }} className="w-full bg-accent-teal hover:bg-accent-teal-hover text-white font-bold text-lg py-4 px-8 rounded-xl transition-all transform hover:scale-[1.02] shadow-md hover:shadow-lg flex items-center justify-center gap-2 mb-6 group no-underline" data-id="element-94">
            Descargalo y empezá hoy
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-95" />
          </a>

          <div className="flex items-center justify-center gap-2 text-sm text-text-secondary mb-8" data-id="element-96">
            <ShieldCheck className="w-4 h-4 text-accent-teal" data-id="element-97" />
            <span data-id="element-98">7 días de garantía de devolución</span>
          </div>

          <div className="text-left bg-warm-section p-6 rounded-lg border border-warm-border" data-id="element-99">
            <p className="text-text-secondary mb-4 italic" data-id="element-100">
              "No te prometo tranquilidad financiera. Te prometo algo mejor:{' '}
              <strong data-id="element-101">aire</strong> y <strong data-id="element-102">control operativo</strong>."
            </p>
            <p className="text-text-secondary mb-4" data-id="element-103">
              Porque cuando recuperás control, volvés a tomar buenas decisiones.
              Y cuando tomás buenas decisiones… el mes deja de correrte.
            </p>
            <p className="font-medium text-accent-teal" data-id="element-104">
              Descargalo y empezá hoy con el Bolsillo 1: Supervivencia.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
}